var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VRAI",
    transform: "translate(0 0.164)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41-icon-correct",
    "data-name": "Ellipse 41",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(0 -0.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11240-icon-correct",
    "data-name": "Path 11240",
    d: "M3.45-23.793a3.623,3.623,0,0,1-1.16,2.5l-.12.12L-4.6-14.051a42.029,42.029,0,0,1-3.673,3.5,4.6,4.6,0,0,1-2.14,1.237,3.256,3.256,0,0,1-1.631-.618A3.118,3.118,0,0,1-13.3-11.2a10.009,10.009,0,0,1-.454-2.321,32.244,32.244,0,0,1-.213-3.842,2.93,2.93,0,0,1,.941-2.085,2.866,2.866,0,0,1,2.08-.958q1.084,0,1.292,1.981.022.23.033.339a9.929,9.929,0,0,0,.405,2.124q.23.6.624.6a1.412,1.412,0,0,0,.613-.356,14.061,14.061,0,0,0,1.073-.969L.046-23.574A10.141,10.141,0,0,1,1.611-24.9a2.281,2.281,0,0,1,1.171-.449.542.542,0,0,1,.514.274,2.006,2.006,0,0,1,.153.92Z",
    transform: "translate(28.007 39.053)",
    fill: "#5dbaa8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrect);
export default __webpack_public_path__ + "static/media/icon-correct.7b2464bc.svg";
export { ForwardRef as ReactComponent };